import userProfile from 'services/clientServices/slice';

import { configureStore } from '@reduxjs/toolkit';

import guidedDetails from 'components/ConsumerGuidedExperienceModal/slice';
import createAccount from 'components/CreateAccountModal/slice';
import distanceDropdownDetails from 'components/DistanceDropdown/slice';
import forgotPassword from 'components/ForgotPasswordModal/slice';
import forgotUsername from 'components/ForgotUsernameModal/slice';
import learningCenterTags from 'components/LearningCenterSearchFilter/slice';
import preferredAgentDetails from 'components/PreferredAgent/slice';
import reduxExample from 'components/ReduxExample/slice';
import doctorDetails from 'components/YourDoctorModal/slice';
import locationDetails from 'components/YourLocationModal/slice';
import medicaidDetails from 'components/YourMedicaidModal/slice';
import pharmacyDetails from 'components/YourPharmacyModal/slice';

import signIn from 'pages/SignInPage/slice';

import enrollDetails from 'temp/components/EnrollModal/slice';
import tempReduxExample from 'temp/components/ReduxExample/slice';
import prescriptionDetails from 'temp/components/YourPrescriptionModal/slice';
import planDetails from 'temp/pages/PlanDetails/slice';
import plansPage from 'temp/pages/Plans/slice';

export default configureStore({
    reducer: {
        createAccount,
        distanceDropdownDetails,
        doctorDetails,
        enrollDetails,
        forgotPassword,
        forgotUsername,
        guidedDetails,
        learningCenterTags,
        locationDetails,
        medicaidDetails,
        pharmacyDetails,
        planDetails,
        plansPage,
        preferredAgentDetails,
        prescriptionDetails,
        reduxExample,
        signIn,
        tempReduxExample,
        userProfile
    }
});
